import React from 'react'
import ReactImageFallback from 'react-image-fallback'
import moment from "moment";
import { MdLocationOn } from 'react-icons/md';
import { toast, ToastContainer } from "react-toastify";

// images
import defaultUser from "../assets/images/default_profile_pic.jpg";
import { useNavigate } from 'react-router-dom';
import { useRef } from 'react';

export default function SingleBid(props) {

    let navigate = useNavigate();
    let bid = useRef(null);

    // assignJobHandler
    const assignJobHandler = async (e) => {
        e.preventDefault();
        
        let assignFormData = new FormData();
        assignFormData.append("post_id", props?.bid?.post_id);
        assignFormData.append("provider_id", props?.bid?.provider_id);
        
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/assign_jobs`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${props?.token}`
            },
            body: assignFormData
        })
        .then(r => r.json())
        .then(response => {
            if(response.success){
                props.setAction("job assigned");
                toast.success("Job Assigned Successfully");
                navigate("/my-jobs", { replace: true });
            } else {
                toast.error(response.message);
            }
        })
    }

    const rejectJob = () => {
        bid.current.style.display = "none";
    }

    return (
        <>
            <div className="bds-sectiontitle w-100" ref={bid}>
                <div className="bg-gray theme-rounded-25 overflow-hidden mt-4">
                    <div className="bds-box bg-gray p-0 border-0 single_proposal">
                        <ReactImageFallback
                            src={`${process.env.REACT_APP_BASE_URL}/public/storage/${props?.bid?.user?.profile_image}`}
                            initialImage={defaultUser}
                            fallbackImage={defaultUser}
                        />
                        <div className="single_proposal_detail ms-4 my-1">
                            <h6>{props?.bid?.user?.first_name != null && props?.bid?.user?.last_name != null ? props?.bid?.user?.first_name + " " + props?.bid?.user?.last_name : props?.bid?.user?.name}</h6>
                            <p className="mb-0 d-flex align-items-center"><MdLocationOn size={"22px"} /> <span className="ms-1 fw-light text-muted">From</span></p>
                            <p className="fw-bold text-truncate">{props?.bid?.post?.address}</p>
                            {
                                props?.bid?.post?.status == 2 ? 
                                <p className='my-3 text-success'>Job Assigned</p> : 
                                (
                                    <>
                                        <button type='button' className="btn bds-btn-solid-sm theme-rounded bg-sky-blue me-2" onClick={(e) => assignJobHandler(e)}>Accept</button>
                                        <button type='button' onClick={() => rejectJob()} className="btn bds-btn-solid-sm theme-rounded border bg-white text-dark">Reject</button>
                                    </>
                                )

                            }

                            <button type='button' className="btn btn-link text-sky-blue text-decoration-none fw-bold" data-bs-toggle="collapse" data-bs-target={`#bidDetail${props?.idx}`}>View details</button>
                        </div>
                        <div className="single_proposal_price">
                            ${props?.bid?.price}
                        </div>
                    </div>
                    <div className="collapse p-3" id={`bidDetail${props?.idx}`}>
                        {props?.bid?.detail}
                    </div>
                </div>
            </div>
            <ToastContainer />
        </>
    )
}
